module.exports = __webpack_public_path__ + "media/native-apps/uppsalalan-9cda02bb.webp";